module.exports = "/img/wizdome.png?f7d03a6a230eba2b84fb2279a344e6a2";